package com.rajen.angrejidictionary.data.remote

import com.rajen.angrejidictionary.data.local.DeviceIdManager
import com.rajen.angrejidictionary.data.remote.dto.WordResponse
import com.rajen.angrejidictionary.data.remote.dto.WordSearchResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

object WordApi {

    private val client = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
                coerceInputValues = true
            })
        }
    }

    suspend fun getTodayWord(): WordResponse {
        return client
            .get(ApiConfig.WORD_ENDPOINT)
            .body()
    }

    // Detail call: every request counts as a view on the backend, so this must only
    // run in the browser (WordDetailPage -> LaunchedEffect), never for prefetching.
    suspend fun getWordByTerm(term: String): WordResponse {
        val deviceId = DeviceIdManager.getDeviceId()
        return client.get(ApiConfig.wordByTermEndpoint(term)) {
            if (deviceId.isNotEmpty()) header("X-Device-Id", deviceId)
        }.body()
    }

    suspend fun searchWords(term: String): WordSearchResponse {
        return client
            .get(ApiConfig.wordSearchEndpoint(term))
            .body()
    }
}